import { useId, type ReactNode } from "react";

import { cn } from "~/lib/cn";

/**
 * One titled section of an app page: an h2, an optional line under it and an
 * optional action on the right, then the content 16px below.
 */
export function PageSection({
  title,
  description,
  action,
  className,
  children,
}: {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}): React.ReactElement {
  const headingId = useId();
  return (
    <section aria-labelledby={headingId} className={cn("space-y-4", className)}>
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
        <div className="min-w-0 space-y-1">
          <h2
            className="font-heading text-xl font-medium text-gray-900"
            id={headingId}
          >
            {title}
          </h2>
          {description && (
            <p className="text-text-secondary text-sm">{description}</p>
          )}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}
